export type DoorControlAction = 0 | 1 | 2 | 3;

export interface DoorMapping {
  /** User-facing door identifier (what user keys in) */
  doorId: number;
  /** IoT controller serial number */
  sn: string;
  /** Door number on controller (1..4) */
  door: 1 | 2 | 3 | 4;
  /** Optional label for UI/debug */
  label?: string;
}

/**
 * Hardcode mappings of "door id" -> IoT device + door number.
 *
 * Update these entries to match your physical deployment.
 * The control panel will refuse to send a command if a door id is not mapped.
 */
export const DOOR_MAPPINGS: Record<number, DoorMapping> = {
  // Example:
  // 1: { doorId: 1, sn: 'YOUR_SERIAL_NUMBER', door: 1, label: 'Main Entrance' },
  1: { doorId: 1, sn: '306EC21A', door: 3, label: 'After Changi Tree' },
  2: { doorId: 2, sn: '306EC21A', door: 4, label: 'End of exhibition' },
  3: { doorId: 3, sn: '50BD60A8', door: 2, label: 'Liberation right door' },
  4: { doorId: 4, sn: '50BD60A8', door: 1, label: 'Liberation left door' },
  5: { doorId: 5, sn: '9522C513', door: 2, label: 'After life of prisoners of wat' },
};

export function resolveDoorMapping(doorId: number): DoorMapping | null {
  if (!Number.isFinite(doorId)) return null;
  return DOOR_MAPPINGS[doorId] ?? null;
}
